export default "__VITE_ASSET__CeAvLYvn__"